export default __webpack_public_path__ + "static/media/1594.4d5f2e3a.png";